<template>
  <div id="listWidget" class="mb-5">
    <div class="instruction-card card-item mb-3">
      <div class="instruction-header">
        <i class="fa-solid fa-info-circle me-2 text-primary"></i>
        <span class="instruction-title">사용 안내</span>
      </div>
      <div class="instruction-body">
        <p class="mb-0" style="font-size: 0.85rem; line-height: 1.6; color: #495057;">
          아래 영역 목록에는 가상스위치 제어기(모델 M91)만 표시됩니다. 추가·설정은 영역 카드에서 선택할 수 있습니다.
        </p>
      </div>
    </div>

    <div class="row">
      <VirtualZoneItem
        v-for="(item, index) in zonesForVirtual"
        :key="item._id"
        :index="index"
        :data="item"
        @onDeleteClick="onDeleteZoneClick"
        @onZoneUpdated="onZoneUpdated"
      />
    </div>
  </div>
</template>

<script setup>
import {
  ref,
  computed,
  getCurrentInstance,
  onBeforeMount,
  onBeforeUnmount,
  onMounted,
  watch,
} from 'vue';
import { useStore } from 'vuex';
import Axios, { ZoneApi } from '@/api';
import VirtualZoneItem from './components/VirtualZoneItem.vue';

const VIRTUAL_SWITCH_MODEL = 'M91';
const store = useStore();
const { emitter } =
  getCurrentInstance().appContext.config.globalProperties;

const zones = ref([]);

const zonesForVirtual = computed(() => {
  return zones.value.map((z) => ({
    ...z,
    controllers: (z.controllers || []).filter(
      (c) => c.model === VIRTUAL_SWITCH_MODEL,
    ),
  }));
});

watch(zones, () => {
  console.log('VirtualSettingPage.watch => zones : ', zones.value);
});

const onDeleteZoneClick = (payload) => {
  const groups = zones.value.find((z) => z._id == payload.zoneId)?.groups;
  if (groups?.length > 0) {
    emitter.emit('showPopConfirm', {
      description: '방정보가 포함된 영역입니다.\n정말 삭제하시겠습니까?',
      okCallback: async () => {
        try {
          await requestDeleteZone(payload.zoneId);
          emitter.emit('showPopAlert', {
            description: '영역이 삭제되었습니다.',
          });
        } catch (e) {
          emitter.emit('showPopAlert', {
            description: e,
          });
        }
      },
      cancelCallback: () => {},
    });
    return;
  }
  requestDeleteZone(payload.zoneId);
};

const onZoneUpdated = () => {
  requestZones();
};

const requestZones = async () => {
  try {
    const result = await Axios.get(ZoneApi.ZONES, { isOwner: true });
    if (result.resultCode === '0000') {
      zones.value = result.resultData;
      return;
    }
    if (result.resultMessage) {
      emitter.emit('showPopAlert', {
        description: result.resultMessage,
      });
    }
    return false;
  } catch (error) {
    emitter.emit('showPopAlert', {
      description: '기존 영역 조회에 실패했습니다.',
    });
    return false;
  }
};

const requestDeleteZone = async (zoneId) => {
  try {
    const result = await Axios.delete(
      ZoneApi.DELETE_ZONE.replace(':id', zoneId),
    );
    if (result.resultCode === '0000') {
      requestZones();
      store.commit('home/deleteZone', zoneId);
      return;
    }

    emitter.emit('showPopAlert', {
      description: result.resultMessage,
    });
  } catch (error) {
    emitter.emit('showPopAlert', {
      description: '기존 영역 조회에 실패했습니다.',
    });
  }
};

onBeforeMount(() => {
  emitter.emit('onChangeHeaderSetting',{title:'가상스위치 설정',isShowMenu:false,isShowZone:false,isShowProfile:false,isShowRightHome:true});
});
onBeforeUnmount(() =>{
  emitter.emit('onChangeHeaderSetting',{title:'',isShowMenu:true,isShowZone:true,isShowProfile:true,isShowRightHome:false});
});

onMounted(async () => {
  await requestZones();
});
</script>

<style scoped>
.instruction-card {
  background-color: #ffffff;
  border: 1px solid #e9ecef;
  border-radius: 1.2rem;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  overflow: hidden;
  transition: box-shadow 0.3s ease;
}

.instruction-card:hover {
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

.instruction-header {
  display: flex;
  align-items: center;
  padding: 0.75rem 1rem;
  background-color: #f8f9fa;
  border-bottom: 1px solid #e9ecef;
}

.instruction-title {
  font-size: 0.9rem;
  font-weight: 600;
  color: #212529;
}

.instruction-body {
  padding: 0.75rem 1rem;
}
</style>
